import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row, Modal, Button } from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment from "moment";
import { Spin } from "antd";
import {
  POST_GetCustomerDDLListAJAX,
  POST_GetCustomerContactPersonDDLByCustomerProject,
  POST_GetCustomerProjectAddressDDLList,
  POST_GetCustomerProjectList,
  POST_GetVoucherSeriesDDLList,
  POST_GetBillingCustomerDetails,
  POST_GetInvoiceInwardNoListByCustomerID,
  POST_GetInvoiceTCNoListByInwardIDs,
  POST_GetInvoiceTestAndMachiningListByInwardMaterialID,
  POST_InvoiceUpdate,
  POST_InvoiceInsert,
  POST_GetInvoiceDetailByID,
  POST_InvoiceBillFileUpload,
  POST_ValidateCustomerCredit,
  POST_GetCompanyLUTDocumentInvoiceDateCheckExpiredOrNot,
  POST_GetReportDispatchInwardNoClubing,
} from "../../../helpers/url_helper";
import { post, postFormData } from "../../../helpers/api_helper";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import CustomMultiSelect from "../../../CustomControls/CustomMultiSelect";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CommonMaterialInformation from "./CommonMaterialInformation";
import {
  customConfirmDialog,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import { SVGICON } from "../../../constant/theme";

const AddInvoice = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [invoiceNoOptions, setInvoiceNoOptions] = useState([]);
  const [inwardNoOptions, setInwardNoOptions] = useState([]);
  const [tCNoOptions, setTCNoOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [projectAddressOptions, setProjectAddressOptions] = useState([]);
  const [contactPersonOptions, setContactPersonOptions] = useState([]);
  const [modeByOptions, setModeByOptions] = useState([]);

  const getModeByDDL = () => {
    setModeByOptions([
      {
        value: 1,
        label: "Email",
      },
      {
        value: 2,
        label: "Post",
      },
      {
        value: 3,
        label: "Hand to Hand",
      },
      {
        value: 4,
        label: "Courier",
      },
    ]);
  };

  const validationSchema = Yup.object().shape({
    VoucherSeriesIDEncrypted: Yup.string().required(
      "Invoice No is required field"
    ),
    InvoiceDate: Yup.string().required("Invoice Date is required field"),
    CustomerIDEncrypted: Yup.string().required("Customer is required field"),
    BillingCustomerIDEncrypted: Yup.string().required(
      "Billing Customer is required field"
    ),
    CustomerProjectIDEncrypted: Yup.string().required(
      "Project is required field"
    ),
    CustomerProjectAddressIDEncrypted: Yup.string().required(
      "Address is required field"
    ),
    CustomerProjectContactPersonIDEncrypted: Yup.string().required(
      "Contact Person is required field"
    ),
    ModeOfDispatch: Yup.string().required("Mode Of Dispatch is required field"),
    InwardIDs: Yup.array()
      .required("Inward No is required field")
      .min(1, "Inward No is required field")
      .nullable(),
    InwardMaterialIDs: Yup.array()
      .required("TC No is required field")
      .min(1, "TC No is required field")
      .nullable(),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      InvoiceIDEncrypted: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      VoucherSeriesIDEncrypted: "",
      InvoiceNo: "",
      InvoiceDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
      BillingCustomerIDEncrypted: "",
      BillingCustomerName: "",
      CustomerProjectIDEncrypted: "",
      CustomerProjectAddressIDEncrypted: "",
      CustomerProjectContactPersonIDEncrypted: "",
      ModeOfDispatch: "",
      BillingRemarks: "",
      GSTNumber: "",
      Narration: "",
      BillingCustomerOutstandingAmount: "0",
      InwardIDs: [],
      InwardMaterialIDs: [],
      ListOfInwardMaterialsDetails: [],
      ListOfExpense: [],
      DiscountPercentageApplyToAll: "",
      unitOptions: [],
      ListOfGSTPlans: [],
      GSTType: 0,
      CalculateGST: true,
      GSTPercentage: "0.00",
      GrossAmount: "0.00", ///* Item wise Total Amount */
      ItemTotalDiscountAmount: "0.00", ///* Item wise Total Discount Amount */
      ItemNetAmount: "0.00", ///* Item wise Total Net Amount */
      AdditionalAmount: "0.00", ///* Expense Total Amount */
      ExpenseTotalDiscountAmount: "0.00", ///* Expense Total Discount Amount */
      ExpenseNetAmount: "0.00", ///* Expense Total NetAmount */
      TotalGrossAmount: "0.00", ///* ItemNetAmount + ExpenseNetAmount */
      DiscountAmount: "0.00", ///* ItemTotalDiscountAmount + ExpenseTotalDiscountAmount */
      GSTAmount: "0.00", ///* Total GST Tax Amount */
      RoundingOff: "0.00", ///* Rounding Amount */
      NetAmount: "0.00", ///* TotalGrossAmount + Total Tax Amount */
      PaymentStatus: false,
      BillExcelFilePath: "",
      BillExcelFileKey: "",
      BillExcelFileUrl: "",
      BillPdfFilePath: "",
      BillPdfFileKey: "",
      BillPdfFileUrl: "",
      FormID: 52, ///* 52 = Invoice */
      calcGross: false,
      calcTaxAndNet: false,
      CustomerPerformaInvoiceRequired: false,
      GenerateEInvoice: false,
      GSTRegistrationType: 0,
      eInvoiceStatus: false,
      CustomerInSEZ: false,
      IsLUTCertificateExpired: false,
      InvoiceType: 2,
      ListOfInwardNoClubing: [],
      IsPrintLineItemRemarks: false,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      InvoiceIDEncrypted,
      VoucherSeriesIDEncrypted,
      InvoiceDate,
      CustomerIDEncrypted,
      CustomerName,
      BillingCustomerIDEncrypted,
      BillingCustomerName,
      BillingCustomerOutstandingAmount,
      CustomerProjectIDEncrypted,
      PaymentStatus,
      BillExcelFilePath,
      BillExcelFileKey,
      BillExcelFileUrl,
      BillPdfFilePath,
      BillPdfFileKey,
      BillPdfFileUrl,
      CalculateGST,
      CustomerPerformaInvoiceRequired,
      GenerateEInvoice,
      GSTRegistrationType,
      GSTNumber,
      eInvoiceStatus,
      CustomerInSEZ,
      IsLUTCertificateExpired,
      InvoiceType,
      ListOfInwardNoClubing,
      IsPrintLineItemRemarks,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    if (PaymentStatus == true) {
      return;
    }

    handleBlurInwardNos(); //to validate Inward No

    if (
      values?.CustomerPerformaInvoiceRequired == true &&
      values?.InwardIDs?.filter((x) => x.IsPerformaInvoice == false)?.length > 0
    ) {
      warningMessage(
        "You can not create Direct Invoice! Proforma Invoice is required for billing customer."
      );
      return;
    }

    if (
      values?.ListOfInwardMaterialsDetails?.filter(
        (item) => item.IsSelected == true
      )?.length == 0
    ) {
      warningMessage("Please select at least one Material Information");
      return;
    }

    setIsLoading(true);

    let inwardList = [],
      testList = [],
      machiningList = [],
      expenseList = [];

    Promise.all(
      values?.ListOfInwardMaterialsDetails?.filter(
        (x) => x.IsSelected == true
      )?.map((item) => {
        inwardList.push({
          InwardIDEncrypted: item?.InwardIDEncrypted,
          InwardMaterialIDEncrypted: item?.InwardMaterialIDEncrypted,
          PerformaInvoiceIDEncrypted: item?.PerformaInvoiceIDEncrypted,
        });
        item?.ListOfTests?.map((test) => {
          testList.push({
            ...test,
            DiscountPercentage: test?.DiscountPercentage
              ? test?.DiscountPercentage
              : "0.00",
            UnitID: test?.UnitID ? test?.UnitID : 0,
          });
        });
        item?.ListOfMachining?.map((machining) => {
          machiningList.push({
            ...machining,
            DiscountPercentage: machining?.DiscountPercentage
              ? machining?.DiscountPercentage
              : "0.00",
          });
        });
      })
    );

    Promise.all(
      values?.ListOfExpense?.filter((x) => x.IsSelected == true)?.map(
        (item) => {
          expenseList.push({
            ...item,
            DiscountPercentage: item?.DiscountPercentage
              ? item?.DiscountPercentage
              : "0.00",
          });
        }
      )
    );

    let payload = {
      ...values,
      InvoiceDate: values?.InvoiceDate
        ? moment(values?.InvoiceDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      DiscountAmount: values?.DiscountAmount?.toString(),
      InwardList: inwardList,
      TestList: testList,
      MachiningList: machiningList,
      ExpenseList: expenseList,
      GSTDetail: values?.ListOfGSTPlans,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
      ModifiedByEncrypted: AuthUser?.ReferenceIDEncrypt,
    };

    delete payload["InwardIDs"];
    delete payload["InwardMaterialIDs"];
    delete payload["ListOfInwardMaterialsDetails"];
    delete payload["ListOfExpense"];
    delete payload["ListOfGSTPlans"];
    delete payload["unitOptions"];
    delete payload["PaymentStatus"];
    delete payload["FormID"];
    delete payload["BillExcelFileKey"];
    delete payload["BillPdfFileKey"];
    //console.log(payload);

    post(
      values?.InvoiceIDEncrypted ? POST_InvoiceUpdate : POST_InvoiceInsert,
      payload
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          // successMessage(response?.Message);
          // setTimeout(() => {
          //   navigate(-1);
          // }, 1000);
          if (!values?.InvoiceIDEncrypted) {
            formik.setFieldValue("InvoiceIDEncrypted", response?.EncryptID);
          }
          saveBillFiles(
            !values?.InvoiceIDEncrypted
              ? response?.EncryptID
              : values?.InvoiceIDEncrypted,
            values,
            response?.Message
          );
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getModeByDDL();
    if (PrimaryIdParam) {
      getInvoiceDetails();
    }
  }, []);

  const getInvoiceDetails = async () => {
    setIsLoading(true);
    await post(POST_GetInvoiceDetailByID, {
      InvoiceIDEncrypted: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          let p = response?.InvoiceInfo;
          formik.setFieldValue(
            "VoucherSeriesIDEncrypted",
            p?.VoucherSeriesIDEncrypted
          );
          formik.setFieldValue("InvoiceNo", p?.InvoiceNo);
          formik.setFieldValue(
            "InvoiceDate",
            p?.InvoiceDate ? new Date(p?.InvoiceDate) : ""
          );
          formik.setFieldValue("CustomerIDEncrypted", p?.CustomerIDEncrypted);
          formik.setFieldValue("CustomerName", p?.CustomerName);
          formik.setFieldValue(
            "BillingCustomerIDEncrypted",
            p?.BillingCustomerIDEncrypted
          );
          formik.setFieldValue("BillingCustomerName", p?.BillingCustomerName);
          formik.setFieldValue(
            "CustomerPerformaInvoiceRequired",
            p?.PerformaInvoiceRequired
          );
          formik.setFieldValue(
            "CustomerProjectIDEncrypted",
            p?.CustomerProjectIDEncrypted
          );
          formik.setFieldValue(
            "CustomerProjectAddressIDEncrypted",
            p?.CustomerProjectAddressIDEncrypted
          );
          formik.setFieldValue(
            "CustomerProjectContactPersonIDEncrypted",
            p?.CustomerProjectContactPersonIDEncrypted
          );
          formik.setFieldValue("ModeOfDispatch", p?.ModeOfDispatch);
          formik.setFieldValue("BillingRemarks", p?.BillingRemarks);
          formik.setFieldValue("GSTNumber", p?.GSTNo);
          formik.setFieldValue("GSTRegistrationType", p?.GSTRegistrationType);
          formik.setFieldValue("GenerateEInvoice", p?.GenerateEInvoice);
          formik.setFieldValue("eInvoiceStatus", p?.GenerateEInvoice);
          formik.setFieldValue("Narration", p?.Narration);
          formik.setFieldValue(
            "BillingCustomerOutstandingAmount",
            p?.BillingCustomerOutstandingAmount
          );
          formik.setFieldValue(
            "IsPrintLineItemRemarks",
            p?.IsPrintLineItemRemarks
          );
          /*if billing Customer Proforma Invoice Required and Invoice generate without Proforma*/
          if (
            p?.PerformaInvoiceRequired == true &&
            response?.InwardNoSelectedList?.filter(
              (x) => x.IsPerformaInvoice == false
            )?.length > 0
          ) {
            formik.setFieldValue("InwardIDs", []);
            formik.setFieldValue("InwardMaterialIDs", []);
          } else {
            formik.setFieldValue(
              "InwardIDs",
              response?.InwardNoSelectedList?.map((item) => ({
                label: item.InwardNo,
                // value: item.InwardIDEncrypted,
                value: item.InwardNo, // to resolve the issue of Inward No selected both when select only one in case of Proforma Invoice and Direct Invoice Inward No for same Inward is display in dropdown
                InwardIDEncrypted: item.InwardIDEncrypted,
                IsPerformaInvoice: item.IsPerformaInvoice,
              }))
            );

            formik.setFieldValue(
              "InwardMaterialIDs",
              response?.TCNoSelectedList?.map((item) => ({
                label: item.TCNo,
                value: item.InwardMaterialIDEncrypted,
                InwardIDEncrypted: item.InwardIDEncrypted,
                PerformaInvoiceIDEncrypted: item.PerformaInvoiceIDEncrypted,
                IsPerformaInvoice: item.PerformaInvoiceIDEncrypted
                  ? true
                  : false,
              }))
            );
          }

          formik.setFieldValue(
            "ListOfInwardMaterialsDetails",
            response?.ListOfInwardMaterialsDetails
          );
          formik.setFieldValue("ListOfExpense", response?.ExpenseList);
          formik.setFieldValue("ListOfGSTPlans", response?.GSTList);
          formik.setFieldValue("GSTType", p?.GSTType);
          formik.setFieldValue("GSTPercentage", p?.GSTPercentage);
          formik.setFieldValue("GrossAmount", p?.GrossAmount);
          formik.setFieldValue("CustomerInSEZ", p?.CustomerInSEZ);
          let itemTotalDiscountAmount = 0,
            itemNetAmount = 0,
            expenseTotalDiscountAmount = 0,
            expenseNetAmount = 0,
            totalGrossAmount = 0;
          Promise.all(
            response?.ListOfInwardMaterialsDetails?.map((item) => {
              Promise.all(
                item?.ListOfTests?.map((test) => {
                  if (item.IsSelected == true) {
                    itemTotalDiscountAmount =
                      itemTotalDiscountAmount +
                      parseFloat(
                        test?.DiscountAmount ? test?.DiscountAmount : 0
                      );
                    itemNetAmount =
                      itemNetAmount +
                      parseFloat(test?.NetAmount ? test?.NetAmount : 0);
                  }
                })
              );
              Promise.all(
                item?.ListOfMachining?.map((m) => {
                  if (item.IsSelected == true) {
                    itemTotalDiscountAmount =
                      itemTotalDiscountAmount +
                      parseFloat(m?.DiscountAmount ? m?.DiscountAmount : 0);
                    itemNetAmount =
                      itemNetAmount +
                      parseFloat(m?.NetAmount ? m?.NetAmount : 0);
                  }
                })
              );
            })
          );
          Promise.all(
            response?.ExpenseList?.filter((x) => x.IsSelected == true)?.map(
              (e) => {
                expenseTotalDiscountAmount =
                  expenseTotalDiscountAmount +
                  parseFloat(e?.DiscountAmount ? e?.DiscountAmount : 0);
                expenseNetAmount =
                  expenseNetAmount +
                  parseFloat(e?.NetAmount ? e?.NetAmount : 0);
              }
            )
          );
          totalGrossAmount =
            parseFloat(itemNetAmount) + parseFloat(expenseNetAmount);
          formik.setFieldValue(
            "ItemTotalDiscountAmount",
            itemTotalDiscountAmount.toFixed(2)
          );
          formik.setFieldValue("ItemNetAmount", itemNetAmount.toFixed(2));
          formik.setFieldValue("AdditionalAmount", p?.AdditionalAmount);
          formik.setFieldValue(
            "ExpenseTotalDiscountAmount",
            expenseTotalDiscountAmount.toFixed(2)
          );
          formik.setFieldValue("ExpenseNetAmount", expenseNetAmount.toFixed(2));
          formik.setFieldValue("TotalGrossAmount", totalGrossAmount.toFixed(2));
          formik.setFieldValue("DiscountAmount", p?.DiscountAmount);
          formik.setFieldValue("GSTAmount", p?.GSTAmount);
          formik.setFieldValue("RoundingOff", p?.RoundingOff);
          formik.setFieldValue("NetAmount", p?.NetAmount);
          formik.setFieldValue("PaymentStatus", p?.PaymentStatus);
          formik.setFieldValue("BillExcelFileUrl", p?.BillExcelPath);
          formik.setFieldValue("BillPdfFileUrl", p?.BillPDFPath);

          // setInwardNoOptions(
          //   response?.InwardListDDL?.map((item) => ({
          //     label: item.InwardNo,
          //     value: item.InwardIDEncrypted,
          //     InwardIDEncrypted: item.InwardIDEncrypted,
          //     IsPerformaInvoice: item.IsPerformaInvoice,
          //   }))
          // );

          /*if billing Customer Proforma Invoice Required then only perfroma invoice list out */
          setInwardNoOptions(
            response?.InwardListDDL?.filter(
              (x) =>
                x.IsPerformaInvoice ==
                (p?.PerformaInvoiceRequired == true
                  ? true
                  : x.IsPerformaInvoice)
            )?.map((item) => ({
              label: item.InwardNo,
              // value: item.InwardIDEncrypted,
              value: item.InwardNo, // to resolve the issue of Inward No selected both when select only one in case of Proforma Invoice and Direct Invoice Inward No for same Inward is display in dropdown
              InwardIDEncrypted: item.InwardIDEncrypted,
              IsPerformaInvoice: item.IsPerformaInvoice,
              IsInwardNoClubing: item.IsInwardNoClubing,
              InwardClubingNo: item?.InwardClubingNo,
            }))
          );

          /*if billing Customer Proforma Invoice Required and Invoice generate without Proforma*/
          if (
            p?.PerformaInvoiceRequired == true &&
            response?.InwardNoSelectedList?.filter(
              (x) => x.IsPerformaInvoice == false
            )?.length > 0
          ) {
            setTCNoOptions([]);
          } else {
            setTCNoOptions(
              response?.TCNoListDDL?.map((item) => ({
                label: item.TCNo,
                value: item.InwardMaterialIDEncrypted,
                InwardIDEncrypted: item.InwardIDEncrypted,
                PerformaInvoiceIDEncrypted: item.PerformaInvoiceIDEncrypted,
                IsPerformaInvoice: item.PerformaInvoiceIDEncrypted
                  ? true
                  : false,
              }))
            );
          }

          getProjectDDL(p?.BillingCustomerIDEncrypted);
          getProjectAddressDDL(
            p?.BillingCustomerIDEncrypted,
            p?.CustomerProjectIDEncrypted
          );
          getContactPersonDDL(
            p?.BillingCustomerIDEncrypted,
            p?.CustomerProjectIDEncrypted
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTestAndMachiningListByInwardMaterialID = async (
    inwardMaterialIDs,
    isPerformaInvoice
  ) => {
    setIsLoading(true);
    await post(POST_GetInvoiceTestAndMachiningListByInwardMaterialID, {
      CustomerIDEncrypted: CustomerIDEncrypted,
      InwardMaterialIDsEncrypted: inwardMaterialIDs,
      IsPerformaInvoice: isPerformaInvoice,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      InvoiceIDEncrypted: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ListOfInwardMaterialsDetails",
            response?.ListOfInwardMaterialsDetails
          );
          formik.setFieldValue("ListOfExpense", response?.ListOfExpense);
          formik.setFieldValue("calcGross", true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!InvoiceDate) {
      formik.setFieldValue("InvoiceDate", "");
    }
    getInvoiceNoDDL();

    if (BillingCustomerIDEncrypted) {
      if (CustomerInSEZ) {
        GetCompanyLUTDocumentInvoiceDateCheckExpiredOrNot(InvoiceDate);
        getBillingCustomerDetails(BillingCustomerIDEncrypted);
      }
    }
  }, [InvoiceDate]);

  const getInvoiceNoDDL = async () => {
    setIsLoading(true);
    await post(POST_GetVoucherSeriesDDLList, {
      TranType: 6, // 6 = Invoice
      TranDate: InvoiceDate
        ? moment(InvoiceDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setInvoiceNoOptions(
            response?.VoucherSeriesList?.map((item) => ({
              label: item.VoucherSeries,
              value: item.VoucherSeriesIDEncrypt,
            }))
          );
          if (VoucherSeriesIDEncrypted) {
            if (
              response?.VoucherSeriesList?.filter(
                (x) => x.VoucherSeriesIDEncrypt == VoucherSeriesIDEncrypted
              )?.length == 0
            ) {
              formik.setFieldValue("VoucherSeriesIDEncrypted", "");
            }
          } else {
            /*select the value when there is only one option while insert only*/
            if (response?.VoucherSeriesList?.length == 1 && !PrimaryIdParam) {
              formik.setFieldValue(
                "VoucherSeriesIDEncrypted",
                response?.VoucherSeriesList[0].VoucherSeriesIDEncrypt
              );
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const loadOptionsCutomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const getCustomerDDL_AJAX = async (inputValue) => {
    return await post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
            PerformaInvoiceRequired: item?.PerformaInvoiceRequired,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const getBillingCustomerDetails = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetBillingCustomerDetails, {
      CustomerIDEncrypted: customerID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      InvoiceDate: InvoiceDate,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue("GSTNumber", response?.GSTNo);
          formik.setFieldValue(
            "GSTRegistrationType",
            response?.GSTRegistrationType
          );
          if (
            response?.GSTRegistrationType == 1 &&
            response?.GSTNo != "" &&
            AuthUser?.EInvoiceApplicable == true
          ) {
            formik.setFieldValue("GenerateEInvoice", true);
          } else {
            formik.setFieldValue("GenerateEInvoice", false);
          }
          formik.setFieldValue("GSTType", response?.GSTType);
          formik.setFieldValue("CalculateGST", response?.CalculateGST);
          formik.setFieldValue("CustomerInSEZ", response?.CustomerInSEZ);

          formik.setFieldValue(
            "GSTPercentage",
            response?.GSTPercentage?.toString()
          );
          formik.setFieldValue(
            "BillingCustomerOutstandingAmount",
            response?.OutstandingAmount
          );
          formik.setFieldValue(
            "ListOfGSTPlans",
            response?.GSTPlanDetailList?.map((item) => ({
              ...item,
              GSTPercentage: item?.GSTPercentage?.toString(),
              GSTAmount: "0.00",
              TaxableAmount: "0.00",
              PerformaInvoiceGSTDetailIDEncrypted: "",
            }))
          );
          formik.setFieldValue("calcTaxAndNet", true);

          if (response?.CustomerInSEZ) {
            if (InvoiceDate) {
              GetCompanyLUTDocumentInvoiceDateCheckExpiredOrNot(InvoiceDate);
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const GetCompanyLUTDocumentInvoiceDateCheckExpiredOrNot = async (InvDate) => {
    setIsLoading(true);
    await post(POST_GetCompanyLUTDocumentInvoiceDateCheckExpiredOrNot, {
      InvoiceDate: InvDate,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "IsLUTCertificateExpired",
            response?.IsLUTCertificateExpired
          );
          if (response?.IsLUTCertificateExpired) {
            customConfirmDialog(
              "The LUT certificate for the selected invoice date has expired.",
              "Do you want to create Invoices?",
              fnCallbackValidateCustomerCredit,
              false
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getProjectDDL = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetCustomerProjectList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CustomerIDEncrypt: customerID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setProjectOptions(
            response?.CustomerProjectDDLList?.map((item) => ({
              label: item.ProjectName,
              value: item.CustomerProjectIDEncrypt,
            }))
          );
          if (
            response?.CustomerProjectDDLList?.length > 0 &&
            CustomerProjectIDEncrypted &&
            response?.CustomerProjectDDLList?.filter(
              (x) => x.CustomerProjectIDEncrypt == CustomerProjectIDEncrypted
            ).length == 0
          ) {
            formik.setFieldValue("CustomerProjectIDEncrypted", "");
            setProjectAddressOptions([]);
            formik.setFieldValue("CustomerProjectAddressIDEncrypted", "");
            setContactPersonOptions([]);
            formik.setFieldValue("CustomerProjectContactPersonIDEncrypted", "");
          } else {
            /*select the value when there is only one option while insert only*/
            if (
              response?.CustomerProjectDDLList?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                "CustomerProjectIDEncrypted",
                response?.CustomerProjectDDLList[0].CustomerProjectIDEncrypt
              );
              getProjectAddressDDL(
                customerID,
                response?.CustomerProjectDDLList[0].CustomerProjectIDEncrypt
              );
              getContactPersonDDL(
                customerID,
                response?.CustomerProjectDDLList[0].CustomerProjectIDEncrypt
              );
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getInwardNoList = async (customerID, performaInvoiceRequired) => {
    if (customerID) {
      setIsLoading(true);
      await post(POST_GetInvoiceInwardNoListByCustomerID, {
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
        CustomerIDEncrypted: customerID,
        InvoiceIDEncrypted: InvoiceIDEncrypted,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            console.log("10", response?.InwardList);
            // setInwardNoOptions(
            //   response?.InwardList?.map((item) => ({
            //     label: item.InwardNo,
            //     value: item.InwardIDEncrypted,
            //     InwardIDEncrypted: item.InwardIDEncrypted,
            //     IsPerformaInvoice: item.IsPerformaInvoice,
            //   }))
            // );

            /*if billing Customer Proforma Invoice Required then only perfroma invoice list out */
            setInwardNoOptions(
              response?.InwardList?.filter(
                (x) =>
                  x.IsPerformaInvoice ==
                  (performaInvoiceRequired == true ? true : x.IsPerformaInvoice)
              )?.map((item) => ({
                label: item.InwardNo,
                // value: item.InwardIDEncrypted,
                value: item.InwardNo, // to resolve the issue of Inward No selected both when select only one in case of Proforma Invoice and Direct Invoice Inward No for same Inward is display in dropdown
                InwardIDEncrypted: item.InwardIDEncrypted,
                IsPerformaInvoice: item.IsPerformaInvoice,
                IsInwardNoClubing: item.IsInwardNoClubing,
                InwardClubingNo: item?.InwardClubingNo,
              }))
            );
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      setInwardNoOptions([]);
      formik.setFieldValue("InwardIDs", []);
      setTCNoOptions([]);
      formik.setFieldValue("InwardMaterialIDs", []);
    }
  };

  const getTCNoList = async (inwardIDs, isPerformaInvoice) => {
    if (inwardIDs) {
      setIsLoading(true);
      await post(POST_GetInvoiceTCNoListByInwardIDs, {
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
        InwardIDsEncrypted: inwardIDs,
        InvoiceIDEncrypted: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
        IsPerformaInvoiceID: isPerformaInvoice,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            let tcList = response?.TCNoList?.map((item) => ({
              label: item.TCNo,
              value: item.InwardMaterialIDEncrypted,
              InwardIDEncrypted: item.InwardIDEncrypted,
              PerformaInvoiceIDEncrypted: item.PerformaInvoiceIDEncrypted,
              IsPerformaInvoice: isPerformaInvoice,
            }));
            setTCNoOptions(tcList);
            formik.setFieldValue("InwardMaterialIDs", tcList);
            getTestAndMachiningListByInwardMaterialID(
              Array.from(tcList, (x) => x.value).join(","),
              isPerformaInvoice
            );

            if (!PrimaryIdParam) {
              /*After selecting Proforma Invoice, load narration based on the latest Proforma invoice made from the selection. */
              if (isPerformaInvoice) {
                formik.setFieldValue(
                  "Narration",
                  response?.PerformaInvoiceNarration
                );
              } else {
                formik.setFieldValue("Narration", "");
              }
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      setTCNoOptions([]);
      formik.setFieldValue("InwardMaterialIDs", []);
      formik.setFieldValue("ListOfInwardMaterialsDetails", []);
      formik.setFieldValue("calcGross", true);
    }
  };

  const getProjectAddressDDL = async (customerID, projectID) => {
    if (customerID && projectID) {
      setIsLoading(true);
      await post(POST_GetCustomerProjectAddressDDLList, {
        CustomerIDEncrypted: customerID,
        CustomerProjectIDEncrypted: projectID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            setProjectAddressOptions(
              response?.ProjectAddressDDLList?.map((item) => ({
                label: item.Address,
                value: item.CustomerProjectAddressIDEncrypted,
              }))
            );
            /*select the value when there is only one option while insert only*/
            if (
              response?.ProjectAddressDDLList?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                "CustomerProjectAddressIDEncrypted",
                response?.ProjectAddressDDLList[0]
                  .CustomerProjectAddressIDEncrypted
              );
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      setProjectAddressOptions([]);
      formik.setFieldValue("CustomerProjectAddressIDEncrypted", "");
    }
  };

  const getContactPersonDDL = async (customerID, projectID) => {
    if (customerID && projectID) {
      setIsLoading(true);
      await post(POST_GetCustomerContactPersonDDLByCustomerProject, {
        CustomerIDEncrypted: customerID,
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        CustomerProjectIDEncrypted: projectID,
      })
        .then((response) => {
          if (response?.IsSuccess) {
            //set only billing contact person
            setContactPersonOptions(
              response?.ListOfContactPersons?.filter(
                (x) => x?.IsBilling == true
              )?.map((item) => ({
                label: item?.ContactPerson,
                value: item?.CustomerProjectContactPersonIDEncrypted,
                IsBilling: item?.IsBilling,
                IsReporting: item?.IsReporting,
                IsDispatch: item?.IsDispatch,
                IsDispatchMaterial: item?.IsDispatchMaterial,
              }))
            );
            /*select the value when there is only one option while insert only*/
            if (
              response?.ListOfContactPersons?.filter(
                (x) => x?.IsBilling == true
              )?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                "CustomerProjectContactPersonIDEncrypted",
                response?.ListOfContactPersons?.filter(
                  (x) => x?.IsBilling == true
                )[0].CustomerProjectContactPersonIDEncrypted
              );
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    } else {
      setContactPersonOptions([]);
      formik.setFieldValue("CustomerProjectContactPersonIDEncrypted", "");
    }
  };

  const handleChangeCustomer = (e) => {
    formik.setFieldValue("CustomerIDEncrypted", e?.value ?? "");
    formik.setFieldValue("CustomerName", e?.label ?? "");
    if ((e?.value ?? "") !== CustomerIDEncrypted) {
      setInwardNoOptions([]);
      formik.setFieldValue("InwardIDs", []);
      setTCNoOptions([]);
      formik.setFieldValue("InwardMaterialIDs", []);
      getInwardNoList(e?.value ?? "", e?.PerformaInvoiceRequired ?? false);
      formik.setFieldValue("ListOfInwardMaterialsDetails", []);
      formik.setFieldValue("calcGross", true);
    }
    if (e) {
      formik.setFieldValue("BillingCustomerIDEncrypted", e?.value);
      formik.setFieldValue("BillingCustomerName", e?.label ?? "");
      formik.setFieldValue(
        "CustomerPerformaInvoiceRequired",
        e?.PerformaInvoiceRequired ?? false
      );
      getProjectDDL(e?.value);
      getBillingCustomerDetails(e?.value);
      ValidateCustomerCredit(e?.value);
    }
  };

  const handleChangeBillingCustomer = (e) => {
    formik.setFieldValue("BillingCustomerIDEncrypted", e?.value ?? "");
    formik.setFieldValue("BillingCustomerName", e?.label ?? "");

    /*if billing Customer Proforma Invoice Required then only Proforma invoice list out */
    if ((e?.PerformaInvoiceRequired ?? false) == true) {
      setInwardNoOptions(
        inwardNoOptions
          ?.filter(
            (x) =>
              x.IsPerformaInvoice ==
              ((e?.PerformaInvoiceRequired ?? false) == true
                ? true
                : x.IsPerformaInvoice)
          )
          ?.map((item) => ({
            label: item.label,
            // value: item.value,
            value: item.label, // to resolve the issue of Inward No selected both when select only one in case of Proforma Invoice and Direct Invoice Inward No for same Inward is display in dropdown
            InwardIDEncrypted: item.InwardIDEncrypted,
            IsPerformaInvoice: item.IsPerformaInvoice,
            IsInwardNoClubing: item.IsInwardNoClubing,
            InwardClubingNo: item?.InwardClubingNo,
          }))
      );

      if (
        formik?.values?.InwardIDs?.filter((x) => x.IsPerformaInvoice == false)
          ?.length > 0
      ) {
        formik.setFieldValue("InwardIDs", []);
        setTCNoOptions([]);
        formik.setFieldValue("InwardMaterialIDs", []);
      }
    } else {
      /*when billing customer does not required proforma then reset inward no list */
      if (CustomerPerformaInvoiceRequired == true) {
        getInwardNoList(CustomerIDEncrypted, false);
      }
    }

    formik.setFieldValue(
      "CustomerPerformaInvoiceRequired",
      e?.PerformaInvoiceRequired ?? false
    );

    if (e) {
      getProjectDDL(e?.value);
      getBillingCustomerDetails(e?.value);
      ValidateCustomerCredit(e?.value);
    } else {
      setProjectOptions([]);
      formik.setFieldValue("CustomerProjectIDEncrypted", "");
      setProjectAddressOptions([]);
      formik.setFieldValue("CustomerProjectAddressIDEncrypted", "");
      setContactPersonOptions([]);
      formik.setFieldValue("CustomerProjectContactPersonIDEncrypted", "");
      formik.setFieldValue("GSTNumber", "");
      formik.setFieldValue("GSTType", 0);
      formik.setFieldValue("GSTPercentage", "0.00");
      formik.setFieldValue("BillingCustomerOutstandingAmount", "0.00");
      formik.setFieldValue("ListOfGSTPlans", []);
      formik.setFieldValue("calcTaxAndNet", true);
      formik.setFieldValue("GSTRegistrationType", 0);
      formik.setFieldValue("GenerateEInvoice", false);
    }
  };

  const handleChangeInwardNos = (e) => {
    let inwards = e ?? [];
    let lastRecordfalg = inwards.length
      ? inwards[inwards.length - 1].IsInwardNoClubing
      : false;

    formik.setFieldValue("InwardIDs", inwards);

    if (
      inwards?.filter((x) => x.IsPerformaInvoice == true)?.length > 0 &&
      inwards?.filter((x) => x.IsPerformaInvoice == false)?.length > 0
    ) {
      formik.setFieldError(
        "InwardIDs",
        "Please select either Direct Inward No or Proforma Invoice No only."
      );
      formik.setFieldTouched("InwardIDs", true);
      return false;
    } else {
      let isPerformaInvoice =
        inwards?.filter((x) => x.IsPerformaInvoice == true)?.length > 0
          ? true
          : false;

      getTCNoList(
        // Array.from(inwards, (x) => x.value).join(","),
        Array.from(inwards, (x) => x.InwardIDEncrypted).join(","), // to resolve the issue of Inward No selected both when select only one in case of Proforma Invoice and Direct Invoice Inward No for same Inward is display in dropdown
        isPerformaInvoice
      );

      if (lastRecordfalg == true) {
        if (inwards?.filter((x) => x.IsInwardNoClubing == true)?.length > 0) {
          // GetInwardNoClubingList(Array.from(inwards, (x) => x.value).join(","));

          GetInwardNoClubingList(
            Array.from(inwards, (x) => x?.InwardClubingNo).join(",")
          );
          // GetInwardNoClubingList(
          //   Array.from(inwards, (x) => x.InwardIDEncrypted).join(",")
          // ); // to resolve the issue of Inward No selected both when select only one in case of Proforma Invoice and Direct Invoice Inward No for same Inward is display in dropdown
        }
      }
    }
    formik.setFieldValue("DiscountPercentageApplyToAll", "");
  };

  const handleBlurInwardNos = () => {
    let inwards = formik.values.InwardIDs;
    if (
      inwards?.filter((x) => x.IsPerformaInvoice == true)?.length > 0 &&
      inwards?.filter((x) => x.IsPerformaInvoice == false)?.length > 0
    ) {
      formik.setFieldError(
        "InwardIDs",
        "Please select either Direct Inward No or Proforma Invoice No only."
      );
      formik.setFieldTouched("InwardIDs", true);
      return false;
    }
  };

  const handleChangeTCNos = (e) => {
    let inwardMaterialIDs = e ?? [];

    formik.setFieldValue("InwardMaterialIDs", inwardMaterialIDs);
    let isPerformaInvoice =
      inwardMaterialIDs?.filter((x) => x.IsPerformaInvoice == true)?.length > 0
        ? true
        : false;
    getTestAndMachiningListByInwardMaterialID(
      Array.from(inwardMaterialIDs, (x) => x.value).join(","),
      isPerformaInvoice
    );
    formik.setFieldValue("DiscountPercentageApplyToAll", "");
  };

  const handleChangeProject = (e) => {
    formik.setFieldValue("CustomerProjectIDEncrypted", e?.value ?? "");
    formik.setFieldValue("CustomerProjectAddressIDEncrypted", "");
    getProjectAddressDDL(BillingCustomerIDEncrypted, e?.value ?? "");
    formik.setFieldValue("CustomerProjectContactPersonIDEncrypted", "");
    getContactPersonDDL(BillingCustomerIDEncrypted, e?.value ?? "");
  };

  const uploadBillExcelFile = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      var pattern = /(.excel|.sheet)$/;

      if (!file.type.match(pattern)) {
        formik.setFieldValue(
          "BillExcelFileKey",
          Math.random().toString(9).substring(2, 9)
        );
        formik.setFieldValue("BillExcelFilePath", "");
        warningMessage("Select valid file!");
      } else {
        formik.setFieldValue("BillExcelFilePath", file);
      }
    } else {
      formik.setFieldValue("BillExcelFilePath", "");
      formik.setFieldValue(
        "BillExcelFileKey",
        Math.random().toString(9).substring(2, 9)
      );
    }
  };

  const downloadBillExcelFile = (e) => {
    window.open(
      BillExcelFilePath
        ? URL.createObjectURL(BillExcelFilePath)
        : BillExcelFileUrl,
      "_blank"
    );
  };

  const deleteBillExcelFile = (e) => {
    formik.setFieldValue("BillExcelFilePath", "");
    formik.setFieldValue(
      "BillExcelFileKey",
      Math.random().toString(9).substring(2, 9)
    );
    formik.setFieldValue("BillExcelFileUrl", "");
  };

  const uploadBillPdfFile = (e) => {
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      var pattern = /(.pdf)$/;

      if (!file.type.match(pattern)) {
        formik.setFieldValue(
          "BillPdfFileKey",
          Math.random().toString(9).substring(2, 9)
        );
        formik.setFieldValue("BillPdfFilePath", "");
        warningMessage("Select valid file!");
      } else {
        formik.setFieldValue("BillPdfFilePath", file);
      }
    } else {
      formik.setFieldValue("BillPdfFilePath", "");
      formik.setFieldValue(
        "BillPdfFileKey",
        Math.random().toString(9).substring(2, 9)
      );
    }
  };

  const downloadBillPdfFile = (e) => {
    window.open(
      BillPdfFilePath ? URL.createObjectURL(BillPdfFilePath) : BillPdfFileUrl,
      "_blank"
    );
  };

  const deleteBillPdfFile = (e) => {
    formik.setFieldValue("BillPdfFilePath", "");
    formik.setFieldValue(
      "BillPdfFileKey",
      Math.random().toString(9).substring(2, 9)
    );
    formik.setFieldValue("BillPdfFileUrl", "");
  };

  const saveBillFiles = (invoiceID, values, message) => {
    setIsLoading(true);
    let formData = new FormData();
    formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
    formData.append("InvoiceIDEncrypted", invoiceID);
    formData.append("BillPDFFile", values?.BillPdfFilePath);
    formData.append("BillExcelFile", values?.BillExcelFilePath);
    formData.append("BillPDFPath", values?.BillPdfFileUrl);
    formData.append("BillExcelPath", values?.BillExcelFileUrl);

    postFormData(POST_InvoiceBillFileUpload, formData)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(message);
          setTimeout(() => {
            navigate(-1);
          }, 1000);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const ValidateCustomerCredit = async (customerId) => {
    setIsLoading(true);
    await post(POST_ValidateCustomerCredit, {
      CustomerIDEncrypt: customerId,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess == false) {
          customConfirmDialog(
            response?.Message,
            "Do you want to create more Invoices?",
            fnCallbackValidateCustomerCredit,
            false
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallbackValidateCustomerCredit = () => {
    navigate(-1);
  };

  const [showInwardNoClubingModal, setShowInwardNoClubingModal] =
    useState(false);

  const GetInwardNoClubingList = async (inwardID) => {
    setIsLoading(true);
    setShowInwardNoClubingModal(true);

    await post(POST_GetReportDispatchInwardNoClubing, {
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
      CustomerIDEncrypt: CustomerIDEncrypted,
      InwardClubingNo: inwardID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ListOfInwardNoClubing",
            response?.ListOfInwardNo
          );
        } else {
          formik.setFieldValue("ListOfInwardNoClubing", []);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="d-flex justify-content-between">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">
                  {InvoiceIDEncrypted ? "Edit" : "Add"} Invoice
                </h4>
              </div>
              {GSTRegistrationType == 1 &&
                GSTNumber != "" &&
                AuthUser?.EInvoiceApplicable == true && (
                  <div
                    className={`d-flex align-items-center pe-2 ${
                      PaymentStatus == false &&
                      (!PrimaryIdParam || eInvoiceStatus == false)
                        ? ""
                        : "disableDiv"
                    }`}
                  >
                    <input
                      type="checkbox"
                      className="form-check-input mt-0"
                      id={"chkGenerateEInvoice"}
                      name={"chkGenerateEInvoice"}
                      checked={GenerateEInvoice}
                      onChange={(e) => {
                        formik.setFieldValue(
                          "GenerateEInvoice",
                          e.target.checked
                        );
                      }}
                    />
                    <label className="mb-1 ps-2">Generate E-Invoice</label>
                  </div>
                )}
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <div
                    className={`${
                      PaymentStatus == false &&
                      (!PrimaryIdParam || eInvoiceStatus == false)
                        ? ""
                        : "disableDiv"
                    }`}
                  >
                    <Row>
                      <Col lg={3}>
                        {!InvoiceIDEncrypted ? (
                          <Field
                            label="Invoice Date"
                            name="InvoiceDate"
                            placeholder={"Select Invoice Date"}
                            component={CustomFlatpickr}
                            options={{
                              altInput: true,
                              altFormat: "j-M-Y",
                              dateFormat: "d-m-Y",
                              maxDate: new Date(),
                            }}
                            required
                          />
                        ) : (
                          <Field
                            label="InvoiceDate"
                            name="InvoiceDate"
                            component={CustomInput}
                            value={moment(InvoiceDate).format("DD-MMM-yyyy")}
                            required
                            disabled={true}
                          />
                        )}
                      </Col>
                      <Col lg={3}>
                        {!InvoiceIDEncrypted ? (
                          <Field
                            label="Invoice No"
                            name="VoucherSeriesIDEncrypted"
                            placeholder={"Select Invoice No"}
                            options={invoiceNoOptions}
                            component={CustomSelect}
                            required
                            autoFocus
                          />
                        ) : (
                          <Field
                            label="Invoice No"
                            name="InvoiceNo"
                            component={CustomInput}
                            required
                            disabled={true}
                          />
                        )}
                      </Col>
                      <Col lg={3}>
                        {!InvoiceIDEncrypted ? (
                          <Field
                            label="Customer"
                            name="CustomerIDEncrypted"
                            placeholder={"Select Customer"}
                            loadOptionsFn={loadOptionsCutomer}
                            component={CustomSelectAsync}
                            title={CustomerName}
                            labelFieldName="CustomerName"
                            required
                            onChange={handleChangeCustomer}
                          />
                        ) : (
                          <Field
                            label="Customer"
                            name="CustomerName"
                            component={CustomInput}
                            required
                            disabled={true}
                          />
                        )}
                      </Col>
                      <Col lg={3}>
                        <span
                          className="me-2 mt-1 fs-12 text-primary"
                          style={{ float: "right" }}
                        >
                          Outstanding Amount :{" "}
                          {BillingCustomerOutstandingAmount}
                        </span>
                        <Field
                          label="Billing Customer"
                          name="BillingCustomerIDEncrypted"
                          placeholder={"Select Billing Customer"}
                          loadOptionsFn={loadOptionsCutomer}
                          component={CustomSelectAsync}
                          title={BillingCustomerName}
                          labelFieldName="BillingCustomerName"
                          required
                          onChange={handleChangeBillingCustomer}
                        />
                      </Col>
                      <Col lg={6}>
                        {CustomerPerformaInvoiceRequired == true && (
                          <span
                            className="me-2 mt-1 fs-12 text-primary"
                            style={{ float: "right" }}
                          >
                            [Proforma Invoice is required for billing customer]
                          </span>
                        )}
                        <Field
                          label="Inward No"
                          name="InwardIDs"
                          placeholder={"Select Inward No"}
                          options={inwardNoOptions}
                          component={CustomMultiSelect}
                          isMulti={true}
                          menuPosition="fixed"
                          required
                          onChange={handleChangeInwardNos}
                          onBlur={handleBlurInwardNos}
                        />
                      </Col>
                      <Col lg={6}>
                        <Field
                          label="TC No"
                          name="InwardMaterialIDs"
                          placeholder={"Select TC No"}
                          options={tCNoOptions}
                          component={CustomMultiSelect}
                          isMulti={true}
                          menuPosition="fixed"
                          required
                          onChange={handleChangeTCNos}
                        />
                      </Col>
                    </Row>
                    <hr className="mt-0 mb-1"></hr>
                    <Row>
                      <label className="text-primary">
                        Billing Information
                      </label>
                      <Col lg={3}>
                        <Field
                          label="Project"
                          name="CustomerProjectIDEncrypted"
                          placeholder={"Select Project"}
                          options={projectOptions}
                          component={CustomSelect}
                          required
                          onChange={handleChangeProject}
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Address"
                          name="CustomerProjectAddressIDEncrypted"
                          placeholder={"Select Address"}
                          options={projectAddressOptions}
                          component={CustomSelect}
                          required
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Contact Person"
                          name="CustomerProjectContactPersonIDEncrypted"
                          placeholder={"Select Contact Person"}
                          options={contactPersonOptions}
                          component={CustomSelect}
                          required
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Mode of Dispatch"
                          name="ModeOfDispatch"
                          placeholder={"Select Mode of Dispatch"}
                          options={modeByOptions}
                          component={CustomSelect}
                          required
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Remarks"
                          name="BillingRemarks"
                          placeholder={"Enter Remarks"}
                          component={CustomInput}
                          maxLength={1000}
                        />
                      </Col>
                      <Col lg={3}>
                        {CustomerInSEZ == true && (
                          <span
                            className="me-2 mt-1 fs-12 text-primary"
                            style={{ float: "right" }}
                          >
                            [Registered in SEZ]
                          </span>
                        )}
                        <Field
                          label="GST Number"
                          name="GSTNumber"
                          component={CustomInput}
                          disabled={true}
                        />
                      </Col>
                      <Col lg={3}>
                        {(BillExcelFileUrl || BillExcelFilePath) && (
                          <>
                            <Link
                              to="#"
                              className="icon-box icon-box-md me-1"
                              title="Delete"
                              style={{ float: "right" }}
                              onClick={deleteBillExcelFile}
                            >
                              {SVGICON.DeleteDanger}
                            </Link>
                            <Link
                              to="#"
                              className="icon-box icon-box-md me-1"
                              title="Download"
                              style={{ float: "right" }}
                              onClick={downloadBillExcelFile}
                            >
                              {SVGICON.Download}
                            </Link>
                          </>
                        )}
                        <div className="mb-2">
                          <label className="mb-1">Upload Bill Excel</label>
                          <input
                            type="file"
                            className="form-control form-control-sm"
                            id="BillExcelFilePath"
                            accept=".xls,.xlsx"
                            key={BillExcelFileKey || ""}
                            onChange={(e) => {
                              uploadBillExcelFile(e);
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={3}>
                        {(BillPdfFileUrl || BillPdfFilePath) && (
                          <>
                            <Link
                              to="#"
                              className="icon-box icon-box-md me-1"
                              title="Delete"
                              style={{ float: "right" }}
                              onClick={deleteBillPdfFile}
                            >
                              {SVGICON.DeleteDanger}
                            </Link>
                            <Link
                              to="#"
                              className="icon-box icon-box-md me-1"
                              title="Download"
                              style={{ float: "right" }}
                              onClick={downloadBillPdfFile}
                            >
                              {SVGICON.Download}
                            </Link>
                          </>
                        )}
                        <div className="mb-2">
                          <label className="mb-1">Upload Bill PDF</label>
                          <input
                            type="file"
                            className="form-control form-control-sm"
                            id="BillPdfFilePath"
                            accept=".pdf"
                            key={BillPdfFileKey || ""}
                            onChange={(e) => {
                              uploadBillPdfFile(e);
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                    <hr className="mt-1 mb-1"></hr>
                    <CommonMaterialInformation />
                    <hr className="mt-1 mb-1"></hr>
                    <Row>
                      <Col lg={12}>
                        <Field
                          label="Narration"
                          name="Narration"
                          placeholder={"Enter Narration"}
                          component={CustomTextArea}
                          maxLength={2000}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="stickyBottomButtons">
                    <hr className="mt-1 mb-2"></hr>
                    {PaymentStatus == false &&
                      (!PrimaryIdParam || eInvoiceStatus == false) && (
                        <button
                          type="submit"
                          className="btn btn-primary btn-sm me-2"
                        >
                          <i className="fa-solid fa-floppy-disk"></i> Submit
                        </button>
                      )}
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={(e) => {
                        navigate(-1);
                      }}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </button>
                  </div>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
          <Modal
            className="fade"
            show={showInwardNoClubingModal}
            onHide={setShowInwardNoClubingModal}
            size="lg"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <Modal.Header>
                <Modal.Title>Clubing Inward No </Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowInwardNoClubingModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg={12}>
                    <div className="mb-1">
                      <span style={{ color: "red" }}>Note : </span>
                      <label>
                        Selected inward is clubbed with other inwards for
                        invoice together.
                      </label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="Clubing-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="Clubing-tbl"
                          className="table dataTable no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="5%">Sr No</th>
                              {/* <th width="10%">Clubing No</th> */}
                              <th width="20%">Inward No</th>
                              <th width="20%">Inward Date</th>
                              <th width="20%">Project Name</th>
                              <th width="15%" style={{ textAlign: "left" }}>
                                Letter Ref No
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {ListOfInwardNoClubing?.length > 0 ? (
                              ListOfInwardNoClubing?.map((item, indx) => (
                                <tr key={indx}>
                                  <td>{indx + 1}</td>
                                  {/* <td>{item.ClubingNo}</td> */}
                                  <td>{item.InwardNo}</td>
                                  <td>{item.InwardDate}</td>
                                  <td>{item.ProjectName}</td>
                                  <td style={{ textAlign: "left" }}>
                                    {item.LetterRefNo}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={6} style={{ textAlign: "left" }}>
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary btn-sm"
                  onClick={() => setShowInwardNoClubingModal(false)}
                >
                  OK
                </Button>
              </Modal.Footer>
            </Spin>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default AddInvoice;
